import { ArrowDownToLineIcon } from 'lucide-react'
import {
  Button,
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@joyful/ui/core'
import { cn } from '@joyful/utils'
import { env } from '@/env'
import { useIsJoyfulSidecarExtensionInstalled } from '@/features/auth/hooks/useIsJoyfulSidecarExtensionInstalled'

export function InstallSidecarExtensionButton() {
  if (!env.VITE_JOYFUL_SIDECAR_EXTENSION_ID) {
    return null
  }

  return (
    <InstallSidecarExtensionButtonContent
      sidecarExtensionId={env.VITE_JOYFUL_SIDECAR_EXTENSION_ID}
    />
  )
}

function InstallSidecarExtensionButtonContent({
  sidecarExtensionId,
}: {
  readonly sidecarExtensionId: string
}) {
  const sidecarInstallQuery =
    useIsJoyfulSidecarExtensionInstalled(sidecarExtensionId)
  const shouldShowInstallButton = sidecarInstallQuery.data === false
  const button = (
    <span
      className={cn(
        'hidden sm:inline-flex',
        shouldShowInstallButton ? null : 'pointer-events-none invisible',
      )}
    >
      <Button
        variant="brand"
        size="xs"
        weight="medium"
        startIcon={<ArrowDownToLineIcon />}
        asChild
      >
        <a
          href={`https://chromewebstore.google.com/detail/${sidecarExtensionId}`}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={shouldShowInstallButton ? undefined : -1}
        >
          {`Get the extension`}
        </a>
      </Button>
    </span>
  )

  if (shouldShowInstallButton === false) {
    return button
  }

  return (
    <HoverCard openDelay={300}>
      <HoverCardTrigger asChild>{button}</HoverCardTrigger>
      <HoverCardContent side="bottom" size="sm">
        <p className="text-sm">
          {`The `}
          <strong>{`Joyful Health Chrome Extension`}</strong>
          {` allows you to see Joyful's work status without leaving your EHR. When a claim is open, the extension shows whether Joyful is working it and recent activity.`}
        </p>
      </HoverCardContent>
    </HoverCard>
  )
}
